import React, { useState } from 'react';
import PropTypes from 'prop-types';
import SvgSprite from '../../atoms/svg-sprite/SvgSprite.jsx';
import trackEvent from '../../../javascripts/helpers/trackEvent';

const handleActiveFilters = (filter, type, activeFilter, setActiveFilter) => {
  if (type === 'multiple') {
    if (activeFilter.some(active => active.slug === filter.slug)) {
      activeFilter.map((active, i) =>
        active.slug === filter.slug ? activeFilter.splice(i, 1) : null
      );
      setActiveFilter([...activeFilter]);
    } else {
      setActiveFilter([...activeFilter, filter]);
      trackEvent('FAQ_Overview_Questions', 'Filter', filter.slug);
    }
  } else {
    setActiveFilter(filter);
    trackEvent('News_Filter', 'Filter', filter.slug);
  }
};

const FilterNavigation = ({
  filters,
  headline,
  headlineOption,
  headlineClassName,
  toggle,
  type,
  activeFilter,
  setActiveFilter,
  hasFilterToggle,
  className
}) => {
  const [filtersAreToggled, toggleFilters] = useState('toggled');

  const isActiveFilter = filter =>
    type === 'multiple'
      ? activeFilter.some(active => active.slug === filter.slug)
      : filter.slug === activeFilter.slug;

  const handleClick = filter => {
    handleActiveFilters(filter, type, activeFilter, setActiveFilter);
  };

  const HeadlineTag = headlineOption || 'h2';

  return (
    <div
      className={`m-filter-navigation has-hoverable-children ${
        hasFilterToggle ? 'has-filter-toggle' : ''
      } ${className}`}
    >
      {headline && (
        <HeadlineTag className={`a-headline m-filter-navigation__headline ${headlineClassName}`}>
          {headline}
        </HeadlineTag>
      )}
      {hasFilterToggle && (
        <button
          type="button"
          className={`m-filter-navigation__filter-toggle ${filtersAreToggled}`}
          onClick={() => toggleFilters(filtersAreToggled === 'toggled' ? '' : 'toggled')}
        >
          {toggle}
          <SvgSprite id="default-arrow-small-down" className="m-filter-navigation__toggle-icon" />
        </button>
      )}
      {filters && filters.length > 0 && (
        <div className="m-filter-navigation__filters">
          {filters.map(filter =>
            type !== 'multiple' ? (
              <div
                className={`m-filter-navigation__filter-tag ${
                  isActiveFilter(filter) ? 'm-filter-navigation__filter-tag--active' : ''
                }`}
                onClick={() => handleClick(filter)}
                onKeyPress={e => (e.key.toLowerCase() === 'enter' ? handleClick(e, filter) : null)}
                tabIndex="0"
                role="button"
                key={filter.slug}
              >
                {filter.label}
              </div>
            ) : (
              <div
                className={`m-filter-navigation__filter-tag m-filter-navigation__filter-tag--multiple ${
                  isActiveFilter(filter) ? 'm-filter-navigation__filter-tag--active' : ''
                }`}
                onClick={() => handleClick(filter)}
                onKeyPress={e => (e.key.toLowerCase() === 'enter' ? handleClick(e, filter) : null)}
                tabIndex="0"
                role="checkbox"
                aria-checked={isActiveFilter(filter) ? 'true' : 'false'}
                key={filter.slug}
              >
                <SvgSprite
                  id="default-filter-check"
                  title="filter-check"
                  className="a-svg-sprite--white"
                />
                <span className="m-filter-navigation__filter-label">{filter.label}</span>
              </div>
            )
          )}
        </div>
      )}
    </div>
  );
};

FilterNavigation.propTypes = {
  type: PropTypes.string,
  className: PropTypes.string,
  headlineClassName: PropTypes.string,
  filters: PropTypes.arrayOf(PropTypes.shape()),
  toggle: PropTypes.string,
  headline: PropTypes.string.isRequired,
  headlineOption: PropTypes.string,
  activeFilter: PropTypes.oneOfType([PropTypes.shape(), PropTypes.arrayOf(PropTypes.shape())])
    .isRequired,
  setActiveFilter: PropTypes.func.isRequired,
  hasFilterToggle: PropTypes.bool
};

FilterNavigation.defaultProps = {
  type: 'default',
  headlineOption: 'h2',
  headlineClassName: '',
  toggle: '',
  filters: [],
  hasFilterToggle: false,
  className: ''
};

export default FilterNavigation;
